var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66663C5.40817 1.66663 1.6665 5.40829 1.6665 9.99996C1.6665 14.5916 5.40817 18.3333 9.99984 18.3333C14.5915 18.3333 18.3332 14.5916 18.3332 9.99996C18.3332 5.40829 14.5915 1.66663 9.99984 1.66663ZM12.3248 10.4416L9.38317 13.3833C9.25817 13.5083 9.09984 13.5666 8.9415 13.5666C8.78317 13.5666 8.62484 13.5083 8.49984 13.3833C8.25817 13.1416 8.25817 12.7416 8.49984 12.5L10.9998 9.99996L8.49984 7.49996C8.25817 7.25829 8.25817 6.85829 8.49984 6.61663C8.7415 6.37496 9.1415 6.37496 9.38317 6.61663L12.3248 9.55829C12.5748 9.79996 12.5748 10.2 12.3248 10.4416Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.7d09d279a67a593d0e04b514c13b1228.svg";
export { ForwardRef as ReactComponent };